<footer class="citizex-footer">
  <div class="footer-container site-content-container">
    <div class="footer-main">
      <div class="footer-column">
        <h2 class="footer-column-title fw-700">Explore</h2>
        <ul class="column-links">
          <li>
            <a class="footer-link" routerLink="/events">Virtual Events</a>
          </li>
          <li>
            <a class="footer-link" routerLink="/representatives">
              Representatives
            </a>
          </li>
          <li><a class="footer-link" routerLink="/posts">Posts</a></li>
          <li><a class="footer-link" routerLink="/polls">Polls</a></li>
          <li>
            <a class="footer-link" routerLink="/announcements">
              Announcements
            </a>
          </li>
        </ul>
      </div>

      <div class="footer-column">
        <h2 class="footer-column-title fw-700">Get Started</h2>
        <ul class="column-links">
          <li>
            <a class="footer-link" routerLink="/signup">Sign Up</a>
          </li>
          <li>
            <a class="footer-link" routerLink="/login">Sign In</a>
          </li>
          <li>
            <a class="footer-link" routerLink="/request-demo"> Request Demo </a>
          </li>
        </ul>
      </div>

      <div class="footer-column">
        <h2 class="footer-column-title fw-700">Legal & Compliance</h2>
        <ul class="column-links">
          <li>
            <a routerLink="/terms-and-conditions" class="footer-link">
              Terms of Service
            </a>
          </li>
          <li>
            <a routerLink="/privacy-and-policy" class="footer-link">
              Privacy Policy
            </a>
          </li>
          <li>
            <a routerLink="/child-safety-policy" class="footer-link">
              Child Safety Policy
            </a>
          </li>
          <li>
            <a class="footer-link" routerLink="/about-us">About Us</a>
          </li>
        </ul>
      </div>

      <div class="footer-column">
        <h2 class="footer-column-title fw-700">Trust & Safety</h2>
        <ul class="column-links">
          <li>
            <a
              href="https://didit.me"
              class="footer-link"
              target="_blank"
              rel="noopener noreferrer"
              >Identity Verification</a
            >
          </li>
          <li>
            <a
              href="https://didit.me/terms/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              class="footer-link"
              >Privacy & Data Protection</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="footer-bottom">
    <div class="footer-bottom__inner site-content-container">
      <p>© {{ currentYear }} CitizeX. All rights reserved.</p>
    </div>
  </div>
</footer>
